import React from 'react';
import { Box, Skeleton } from '@mui/material';
import CrownReward from '@src/assets/images/crown-reward.png';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import { formatNumberWithSuffix } from '@src/utils/number';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '@src/services/package';
import {
  HeaderRow,
  RankNumber,
  RewardContainer,
  RewardIcon,
  Table,
  TableCell,
  TableRow,
} from '../index.style';

const Reward = ({ prizes, isLoading }) => {
  const { i18n, t } = useTranslation();
  const { language } = i18n;

  return (
    <RewardContainer>
      <HeaderRow>
        <Box style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <Typography variant="body-20-bold" color={COLOR.darkGray}>
            {t('rankRewards')}
          </Typography>
          <Typography variant="body-14-regular" color={COLOR.descriptionUpload}>
            {t('rewardsDescription')}
          </Typography>
        </Box>
        <Box>
          <img src={CrownReward} alt="Crown Reward" />
        </Box>
      </HeaderRow>
      <Table>
        <TableRow header height="48px">
          <TableCell>
            <Typography
              variant="body-14-medium"
              color={COLOR.descriptionGray}
              style={{ textAlign: 'center' }}
            >
              {t('rank')}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography
              variant="body-14-medium"
              color={COLOR.descriptionGray}
              style={{ textAlign: 'center' }}
            >
              {t('requiredCharacterUsage')}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography
              variant="body-14-medium"
              color={COLOR.descriptionGray}
              style={{ width: '100%', textAlign: 'center' }}
            >
              {t('rewards')}
            </Typography>
          </TableCell>
        </TableRow>
        {(isLoading ? Array.from({ length: 3 }) : prizes || []).map((item) => (
          <TableRow key={item?.rank}>
            <TableCell>
              {isLoading ? (
                <Skeleton variant="text" width={70} height={30} />
              ) : (
                <RankNumber background={item.background}>
                  {item.rank}
                </RankNumber>
              )}
            </TableCell>
            <TableCell>
              <Typography
                variant="body-14-medium"
                color={COLOR.descriptionGray}
              >
                {isLoading ? (
                  <Skeleton variant="text" width={70} height={30} />
                ) : (
                  formatNumberWithSuffix(item.minCreditsByRank, language)
                )}
              </Typography>
            </TableCell>
            <TableCell>
              {isLoading ? (
                <Skeleton variant="text" width={70} height={30} />
              ) : (
                <>
                  <RewardIcon
                    src={item.badge?.imageUrl}
                    alt={`Reward ${item.rank}`}
                  />{' '}
                  +
                  <Typography
                    variant="body-14-medium"
                    color={COLOR.descriptionGray}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: formatPrice({
                        vndPrice: item.money.amount,
                        usdPrice: 0,
                        isVietNam: true,
                        language,
                      }),
                    }}
                  />
                </>
              )}
            </TableCell>
          </TableRow>
        ))}
      </Table>
    </RewardContainer>
  );
};

export default Reward;
